import styled from '@emotion/styled';
import { css } from '@emotion/react';
import VerticalFlex from '../../../components/flex_layouts/VerticalFlex';
import { Text6 } from '../../../components/typography/Text6';
import Colors from '../../../components/theme/colors';
import { MouseEventHandler } from 'react';

interface Props {
  text: string;
  isSelected?: boolean;
  onClick?: MouseEventHandler;
}

const TableTab = ({ isSelected, text, onClick, ...props }: Props) => {
  return (
    <LayoutRoot isSelected={isSelected} onClick={onClick} {...props}>
      <Text isSelected={isSelected}>{text}</Text>
    </LayoutRoot>
  );
};

export default TableTab;

const LayoutRoot = styled(VerticalFlex)<{ isSelected?: boolean }>`
  cursor: pointer;
  justify-content: center;
  background: ${Colors.gray_1};
  padding: 10.5px 12px;
  border-radius: 8px;

  width: fit-content;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background: linear-gradient(96deg, #e85936 -10.84%, #ffa994 196.74%);
    `}
`;

const Text = styled(Text6)<{ isSelected?: boolean }>`
  color: ${Colors.gray_2};

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: ${Colors.white};
    `}
`;
